/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AnalyticsStrictHttpResponse } from '../../analytics-strict-http-response';
import { AnalyticsRequestBuilder } from '../../analytics-request-builder';

import { AnalyticsMarginResponseDto } from '../../models/analytics-margin-response-dto';

export interface MarginControllerDeleteByProject$Params {
  tenant: string;
  projectId: string;
}

export function marginControllerDeleteByProject(http: HttpClient, rootUrl: string, params: MarginControllerDeleteByProject$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>> {
  const rb = new AnalyticsRequestBuilder(rootUrl, marginControllerDeleteByProject.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>;
    })
  );
}

marginControllerDeleteByProject.PATH = '/o2-analytics/margins/{tenant}/project/{projectId}';
